import React, { useState } from 'react'
import { Header, Modal } from 'semantic-ui-react'
import SocialButtons from './SocialButtons'
import { Input, TextArea } from 'semantic-ui-react'
import { Tab } from 'semantic-ui-react'
function Share(props) {
    // Id of the field whose Copy button was clicked last, so only that button says "Copied!".
    const [copied, setCopied] = useState(null);

    const onCopy = (id, text) => {


        if (typeof gtag === "function")
            gtag('event', text, { 'event_category': 'share', 'event_label': text });


        setCopied(id)
        const textField = document.createElement('textarea');
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        document.getElementById(id).select();
    }

    const panes = [

        {
            menuItem: 'URL',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                Circuit URL (e-mail, IM, blog, etc.):
                <a style={{ marginLeft: 10, padding: 5 }} rel="external" target="_blank" href={props.circuit.email_share} className="ui email circular icon button" role="button"><i aria-hidden="true" className="envelope icon"></i></a>
                <a style={{ marginLeft: 5, padding: 5 }} rel="external" target="_blank" href={props.circuit.facebook_share} className="ui facebook circular icon button" role="button"><i aria-hidden="true" className="facebook icon"></i></a>
                <a style={{ marginLeft: 5, padding: 5 }} rel="external" target="_blank" href={props.circuit.twitter_share} className="ui twitter circular icon button" role="button"><i aria-hidden="true" className="twitter icon"></i></a>
                <a style={{ marginLeft: 5, padding: 5 }} rel="external" target="_blank" href={props.circuit.linkedin_share} className="ui linkedin circular icon button" role="button"><i aria-hidden="true" className="linkedin icon"></i></a>


                <Input
                    fluid className="lab-input"
                    onClick={(e) => { e.target.select() }}
                    id="share_field_url"
                    action={{ disabled: false, onClick: () => onCopy('share_field_url', props.circuit.share_url), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_url' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.share_url}
                />
                {props.contentPageUrl &&
                    <div style={{ marginTop: 14 }}>
                        {(props.l && props.l.circuit_page) || 'Circuit page'}:
                        <Input
                            fluid className="lab-input"
                            onClick={(e) => { e.target.select() }}
                            id="share_field_circuit_page"
                            action={{ disabled: false, onClick: () => onCopy('share_field_circuit_page', props.contentPageUrl), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_circuit_page' ? 'Copied!' : 'Copy' }}
                            value={props.contentPageUrl}
                        />
                    </div>
                }
            </Tab.Pane>,
        },
        {
            menuItem: 'PNG',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                Circuit PNG: (download or hot-link)
                <Input
                    onClick={(e) => { e.target.select() }}
                    fluid className="lab-input"
                    id="share_field_png"

                    action={{ disabled: false, onClick: () => onCopy('share_field_png', props.circuit.thumbnail_url), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_png' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.thumbnail_url}
                />
            </Tab.Pane>,
        },
        {
            menuItem: 'BBCode',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                BBCode (many online discussion forums):
                <Input
                    onClick={(e) => { e.target.select() }}
                    fluid className="lab-input"
                    id="share_field_bbcode"

                    action={{ disabled: false, onClick: () => onCopy('share_field_bbcode', props.circuit.bb_code), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_bbcode' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.bb_code}
                />
            </Tab.Pane>,
        },
        {
            menuItem: 'Markdown',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                Markdown:
                <Input
                    onClick={(e) => { e.target.select() }}
                    fluid className="lab-input"
                    id="share_field_markdown"

                    action={{ disabled: false, onClick: () => onCopy('share_field_markdown', props.circuit.markdown), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_markdown' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.markdown}
                />
            </Tab.Pane>,
        },
        {
            menuItem: 'HTML',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                HTML:
                <Input
                    onClick={(e) => { e.target.select() }}
                    fluid className="lab-input"
                    id="share_field_html"

                    action={{ disabled: false, onClick: () => onCopy('share_field_html', props.circuit.html), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_html' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.html}
                />
            </Tab.Pane>,
        },
        {
            menuItem: 'iframe',
            render: () => <Tab.Pane attached={false} style={{ border: 'none' }}>
                Circuit iframe (webpage):
                <Input
                    onClick={(e) => { e.target.select() }}
                    fluid className="lab-input"
                    id="share_field_iframe"

                    action={{ disabled: false, onClick: () => onCopy('share_field_iframe', props.circuit.iframe_code), color: 'green', labelPosition: 'right', icon: 'copy', content: copied === 'share_field_iframe' ? 'Copied!' : 'Copy' }}
                    value={props.circuit.iframe_code}
                />
            </Tab.Pane>,
        },
    ]


    return (
        <Modal
            closeIcon
            open={props.opened}
            onClose={() => { setCopied(null); props.setShareOpen(false) }}
            onOpen={() => props.setShareOpen(true)}
        >
            <Modal.Header icon='code' content={l.link_and_share} style={{ textAlign: 'center' }} />

            <Header content={l.copy_and_paste} style={{ fontWeight: 'inherit', textAlign: 'center' }} />


            <Modal.Content>

                <Tab

                    menu={{ secondary: true }} panes={panes} onTabChange={(e) => {

                        if (typeof gtag === "function")
                            gtag('event', 'share ' + e.target.innerText, { 'event_category': 'share', 'event_label': 'share ' + e.target.innerText });
                        setCopied(null)
                    }} />


            </Modal.Content>
        </Modal>
    )
}

export default Share
